import React, { useContext } from "react";

import ArticleFeed from "./ArticleFeed";
import AuthContext from "../../Auth/AuthContext";
import ButtonLink from "../../Navigation/ButtonLink";
import NewsletterCTA from "../../Newsletter/NewsletterCTA";
import { default as categoriesConfig } from "../../../categoriesArticles.json";
import { makeStyles } from "@material-ui/core/styles";
import { queryArticles } from "../../../graphql/queries";
import { useRouter } from "next/router";
import useSWR from "swr";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(4),
  },
  addArticle: {
    backgroundColor: "green",
    position: "fixed",
    zIndex: 1000,
  },
  filterBar: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    marginBottom: theme.spacing(3),
  },
  filterBarWithSearchBarContent: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    marginBottom: theme.spacing(3),
  },
  placeholder: {
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    fontWeight: 300,
    marginBottom: theme.spacing(0),
  },
  short: {
    textAlign: "center",
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(4),
    marginLeft: theme.globalMarginMobile,
    marginRight: theme.globalMarginMobile,
    "& p": {
      maxWidth: 450,
      display: "inline-block",
    },
  },
  stickybar: {
    transition: "margin-top 0.33s ease-in",
    display: "block",
    position: "relative",
  },
}));

const Articles = (props) => {
  const { defaultCategory, articleGroup, prefetchedData } = props;
  const classes = useStyles();
  const router = useRouter();
  const { s } = router.query;
  const searchString = s ? `${s}` : "";
  const {
    auth: { isAdmin },
  } = useContext(AuthContext);
  const { t, lang: locale } = useTranslation("common");
  const toplevelCategory = articleGroup === "apps" ? "allapps" : "all";
  const category =
    articleGroup === "apps" && defaultCategory === "all"
      ? "allapps"
      : defaultCategory
      ? defaultCategory
      : toplevelCategory;
  const categories = articleGroup === "apps" ? categoriesConfig.categoriesInApps : categoriesConfig.categoriesInBlog;

  const { data } = useSWR([
    queryArticles,
    JSON.stringify({
      action: "search",
      searchString: searchString || null,
      categories:
        category == "all"
          ? categoriesConfig.categoriesInBlog
          : category == "allapps"
          ? categoriesConfig.categoriesInApps
          : [category],
      visibility: isAdmin ? "publicAndHidden" : "public",
      size: 1000,
      locale,
    }),
  ]);

  if (!data && !prefetchedData)
    return (
      <div className={classes.root}>
        <div className={classes.placeholder} />
      </div>
    );

  const allArticles = (data ? data.queryArticles?.items : prefetchedData) || [];
  const articles = allArticles.filter((article) => article.locale == "de");

  return (
    <>
      <NewsletterCTA layout={category == "tests" ? "tests" : "general"} page={`article-list-${category}`} />
      <div
        className={classes.root}
        data-test={
          articleGroup == "apps"
            ? `page-apps-digitale-services-${category}`
            : category == "all"
            ? "page-blog"
            : `page-blog-${category}`
        }
      >
        {isAdmin && (
          <ButtonLink buttonClassName={classes.addArticle} href="/blog/add" as="/blog/add">
            {t("articlesAdd")}
          </ButtonLink>
        )}
        <h1 className={classes.title}>{t(`articleCategory_${category.replace("-", "_")}_title`)}</h1>
        <div className={classes.short}>
          <p>{t(`articleCategory_${category.replace("-", "_")}_short`)}</p>
        </div>
        <ArticleFeed articles={articles} />
      </div>
    </>
  );
};

export default Articles;
